/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import useInterval from '../../../utilities/hooks/useInterval';
import { constructCn } from '../../../utilities/helperFunctions';

import './PostBoxCTA.scss';

const PostBoxCTA = ({ onClick, placeholderText }) => {
    const [cursorVisible, setCursorVisible] = React.useState(true);

    const toggleCursor = () => setCursorVisible((c) => !c);

    useInterval(toggleCursor, 750);

    const handleClick = React.useCallback(() => {
        if (onClick) {
            // set focus on mock input to trigger keyboard for IOS devices
            const mockInputForIosFocusElement = document.getElementById(
                'mock-input-for-ios-focus'
            );
            mockInputForIosFocusElement.focus();

            onClick();
        }
    }, [onClick]);

    const cursorCn = constructCn('cta-cursor', cursorVisible && 'active');
    return (
        <div
            role="button"
            tabIndex={0}
            className="component-UnifiedPostBox-PostBoxCTA"
            onClick={handleClick}
        >
            <span className={cursorCn}>|</span>
            {placeholderText?.length > 0
                ? placeholderText
                : 'Ask anything (even anonymously) ...'}
        </div>
    );
};

PostBoxCTA.displayName = 'PostBoxCTA';

PostBoxCTA.propTypes = {
    onClick: PropTypes.func.isRequired,
    placeholderText: PropTypes.string,
};
PostBoxCTA.defaultProps = {
    placeholderText: '',
};

export default PostBoxCTA;
